/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AbsencesInputs */

const en_nav_absences = /** @type {(inputs: Nav_AbsencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absences`)
};

const de_nav_absences = /** @type {(inputs: Nav_AbsencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abwesenheiten`)
};

/**
* | output |
* | --- |
* | "Absences" |
*
* @param {Nav_AbsencesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_absences = /** @type {((inputs?: Nav_AbsencesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AbsencesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_absences(inputs)
	return de_nav_absences(inputs)
});